import { ImplementationRequestModal } from './implementation-request-modal.component';

/**
 * Component for rendering the implementation request button
 */
export class ImplementationRequestButtonComponent {
  /**
   * Render the implementation request button
   * @param auditName - The name of the audit (for context)
   * @param placement - Where the button is placed ('header', 'top', or 'bottom')
   * @returns HTML string for the button
   */
  render(auditName: string, placement: 'header' | 'top' | 'bottom' = 'bottom'): string {
    const containerClass = placement === 'header'
      ? 'header-implementation-request-button-container'
      : 'implementation-request-button-container';
    const placementClass = placement === 'header' ? 'header-placement' : (placement === 'top' ? 'top-placement' : '');

    return `
      <div class="${containerClass} ${placementClass}">
        <button class="implementation-request-btn" data-audit-name="${auditName}">
          <span>Get These Fixes Implemented</span>
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
          </svg>
        </button>
      </div>
    `;
  }

  /**
   * Attach event handlers to all implementation request buttons
   */
  attachHandlers(): void {
    const buttons = document.querySelectorAll('.implementation-request-btn');
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const auditName = button.getAttribute('data-audit-name') || '';
        this.openRequestModal(auditName);
      });
    });
  }

  /**
   * Open the implementation request modal
   * @param auditName - The name of the audit
   */
  private openRequestModal(auditName: string): void {
    const modal = new ImplementationRequestModal();
    modal.open(auditName);
  }
}
